import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';

import TrashcanIcon from '~/components/icons/TrashcanIcon';
import TextField from '~/components/TextField';

import styles from './Webhook.style';

class Webhook extends React.Component {
  getHeadersWithNew = () => {
    const { webhook } = this.props;

    let headers = webhook.headers.slice(0);
    headers.push({ name: '', value: '' });

    return headers;
  };

  onChange = (attrs) => {
    const { webhook } = this.props;
    this.props.onChange(Object.assign({}, webhook, attrs));
  };

  onChangeURL = (event) => {
    this.onChange({ url: event.target.value });
  };

  onBlurHeader = (index) => {
    const { webhook, onUpdate } = this.props;

    let headers = webhook.headers.slice(0);

    if (index < headers.length) {
      let header = headers[index];

      // Remove header if it is blank
      if (!header.name && !header.value) {
        headers.splice(index, 1);
      }

      this.onChange({ headers: headers });
    }

    onUpdate();
  };

  onChangeHeader = (index, header) => {
    const { webhook } = this.props;

    let headers = webhook.headers.slice(0);

    if (index === -1) {
      headers.push(header);
    } else if (!header.name && !header.value) {
      headers.splice(index, 1);
    } else {
      headers.splice(index, 1, header);
    }

    this.onChange({ headers: headers });
  };

  onChangeHeaderName = (index, event) => {
    const { webhook } = this.props;

    let header = Object.assign({}, webhook.headers[index]) || {};
    header.name = event.target.value;

    this.onChangeHeader(index, header);
  };

  onChangeHeaderValue = (index, event) => {
    const { webhook } = this.props;

    let header = Object.assign({}, webhook.headers[index]) || {};
    header.value = event.target.value;

    this.onChangeHeader(index, header);
  };

  renderHeader = (header, index) => {
    const { classes } = this.props;

    return (
      <div className={classes.header} key={index}>
        <Grid container className={classes.headerFields} spacing={24}>
          <Grid item xs={6}>
            <TextField
              name="Header name"
              label="Header name"
              value={header.name || ''}
              onChange={this.onChangeHeaderName.bind(this, index)}
              onBlur={this.onBlurHeader.bind(this, index)}
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              name="Header value"
              label="Header value"
              value={header.value || ''}
              onChange={this.onChangeHeaderValue.bind(this, index)}
              onBlur={this.onBlurHeader.bind(this, index)}
            />
          </Grid>
        </Grid>
      </div>
    );
  };

  render() {
    const { classes, onRemove, onUpdate, webhook, key } = this.props;

    return (
      <div key={key} className={classes.root}>
        <div className={classes.actions}>
          <IconButton onClick={onRemove}>
            <TrashcanIcon />
          </IconButton>
        </div>

        <Grid container className={classes.headerFields} spacing={24}>
          <Grid item xs={12}>
            <div className={classes.input}>
              <TextField
                fullWidth
                name="Webhook URL"
                label="Webhook URL"
                type="url"
                placeholder="https://example.com/callback"
                value={webhook.url || ''}
                onChange={this.onChangeURL.bind(this)}
                onBlur={onUpdate}
              />
            </div>
          </Grid>
        </Grid>

        {this.getHeadersWithNew().map(this.renderHeader)}
      </div>
    );
  }
}

Webhook.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  webhook: PropTypes.object.isRequired,
  key: PropTypes.number,
};

export default withStyles(styles)(Webhook);
